/* BUDS — חיבור טופס ה-HTML של פופאפ פלאשי ל-API של פלאשי.
   שתי מכשלות של הפיקסל: (1) הוא קושר form.flashy-form רק בטעינת העמוד, לפני
   שהפופאפ מוזרק. (2) הפופאפ מוזרק לתוך <flashy-popup> עם Shadow DOM — אירועי
   submit לא חוצים את הגבול, אז מאזין ברמת ה-document לא שומע אותם.
   הפתרון: MutationObserver שתופס כל flashy-popup שנוצר ומאזין ל-submit בתוך
   ה-shadow root שלו, בנוסף למאזין רגיל לטפסים שיושבים ב-DOM הרגיל. */
(function () {
  'use strict';

  var FLASHY_ACCOUNT_ID = 12682;
  var DEFAULT_LIST_ID = '38284'; // רשימת BUDS

  // ⛔ מתג חירום: true = הפופאפים של פלאשי מוסרים מהאתר ברגע שהם מוזרקים.
  // אוריה ביקש להוריד את הפופאפ (2026-07-05). להחזרה: false + פריסה.
  var POPUPS_DISABLED = true;

  function isPopupForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    return !!(form.closest('#buds-pop') || form.classList.contains('flashy-form'));
  }

  function directCreate(email, listId) {
    var lists = {};
    lists[listId] = true;
    return fetch('https://api.flashy.app/thunder/contact?overwrite=true&primary_key=email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ account_id: FLASHY_ACCOUNT_ID, contact: { email: email, lists: lists } })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || !res.success) throw new Error('flashy contact create failed');
      return res;
    });
  }

  function createContact(email, listId) {
    var f = window.flashy;
    if (f && f.contacts && typeof f.contacts.createOrUpdate === 'function') {
      // ה-API הרשמי של הפיקסל — גם יוצר את איש הקשר וגם מזהה את הגולש,
      // כך שאירועי עגלה מכאן והלאה נקשרים אליו (נטישת עגלה).
      return f.contacts.createOrUpdate({ email: email }, listId);
    }
    return directCreate(email, listId).then(function (res) {
      try { window.flashy && window.flashy('setCustomer', { email: email }); } catch (e) { /* בלי פיקסל אין זיהוי, האיש קשר עדיין נוצר */ }
      return res;
    });
  }

  function showSuccess(form) {
    var scope = form.closest('#buds-pop') || form.getRootNode() || document;
    var hide = scope.querySelectorAll('.flashy-hide-success');
    var show = scope.querySelectorAll('.flashy-success');
    for (var i = 0; i < hide.length; i++) hide[i].style.display = 'none';
    for (var j = 0; j < show.length; j++) show[j].style.display = 'block';
    if (!show.length) form.innerHTML = '<div style="padding:14px 0;font-weight:700;">נרשמת! 🎉</div>';
  }

  function showFailure(form) {
    var failed = form.querySelector('.flashy-failed');
    if (failed) failed.style.display = 'block';
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!isPopupForm(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (form.dataset.budsSubmitting === '1') return;

    var emailInput = form.querySelector('input[type="email"], input[name="email"]');
    var email = emailInput && emailInput.value && emailInput.value.trim();
    if (!email) return;

    var listInput = form.querySelector('input[name="list_id"]');
    var listId = (listInput && listInput.value) || DEFAULT_LIST_ID;

    var btn = form.querySelector('button[type="submit"], button');
    var failed = form.querySelector('.flashy-failed');
    if (failed) failed.style.display = 'none';
    form.dataset.budsSubmitting = '1';
    if (btn) { btn.dataset.budsText = btn.textContent; btn.disabled = true; btn.textContent = 'שולח...'; }

    createContact(email, listId).then(function () {
      form.dataset.budsSubmitting = '';
      showSuccess(form);
    }).catch(function () {
      form.dataset.budsSubmitting = '';
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.budsText || btn.textContent; }
      showFailure(form);
    });
  }

  // טפסים ב-DOM הרגיל (אם אי פעם הפופאפ יוזרק בלי Shadow DOM)
  document.addEventListener('submit', handleSubmit, true);

  // טפסים בתוך ה-Shadow DOM של פופאפי פלאשי
  var boundRoots = typeof WeakSet === 'function' ? new WeakSet() : { has: function () { return false; }, add: function () {} };

  function bindShadow(el, attempt) {
    if (!el) return;
    if (POPUPS_DISABLED) { el.remove(); return; }
    if (!el.shadowRoot) {
      // ה-shadow root עשוי להיווצר רגע אחרי שהאלמנט נוסף — ננסה שוב קצת
      attempt = attempt || 0;
      if (attempt < 20) setTimeout(function () { bindShadow(el, attempt + 1); }, 250);
      return;
    }
    if (boundRoots.has(el.shadowRoot)) return;
    boundRoots.add(el.shadowRoot);
    el.shadowRoot.addEventListener('submit', handleSubmit, true);
  }

  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.tagName === 'FLASHY-POPUP') bindShadow(node);
    var found = node.querySelectorAll ? node.querySelectorAll('flashy-popup') : [];
    for (var i = 0; i < found.length; i++) bindShadow(found[i]);
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document.documentElement);
})();
